const TURNSTILE_SITE_KEY = "0x4AAAAAADOO8coe1t-L_xK-";

let _turnstilePromise = null;
function loadTurnstile() {
  if (_turnstilePromise) return _turnstilePromise;
  _turnstilePromise = new Promise((resolve) => {
    if (window.turnstile) return resolve();
    const s = document.createElement("script");
    s.src =
      "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    s.async = true;
    s.onload = resolve;
    document.head.appendChild(s);
  });
  return _turnstilePromise;
}

$(document).ready(() => {
  // Event delegation — attaches once at document level, works regardless of when forms render
  document.addEventListener("submit", async (e) => {
    e.preventDefault();
    const form = e.target.closest(".modal-form-wrapper form");
    if (!form) return;

    const name = form.querySelector('[name="contact[firstName]"]')?.value;
    const email = form.querySelector('[name="contact[email]"]')?.value;
    const phone = form.querySelector('[name="contact[phone]"]')?.value;
    const message = form.querySelector('[name="contact[comment]"]')?.value;
    const productName = form.querySelector('[name="contact[product]"]')?.value;
    const turnstileToken = form.querySelector(
      '[name="cf-turnstile-response"]',
    )?.value;

    const form_message = form
      .closest(".modal-form-wrapper")
      ?.querySelector(".form__message");

    const submit_btn = form.querySelector('[type="submit"]');

    if (!turnstileToken) {
      if (form_message) {
        form_message.textContent = "Please complete the security check.";
        form_message.style.display = "block";
      }
      return;
    }

    if (submit_btn) {
      submit_btn.disabled = true;
      submit_btn.style.opacity = "0.5";
    }

    try {
      const response = await fetch(
        "https://api.atdigital.io/cove/client-email",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email,
            name,
            productName,
            phone,
            message,
            turnstileToken,
          }),
        },
      );

      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      await response.json();

      form.querySelectorAll("input, textarea").forEach((field) => {
        if (field.name !== "contact[product]") field.value = "";
      });

      if (form_message) {
        form_message.style.display = "block";
      }

      Toastify({
        text: "Form submitted successfully",
        duration: 5000,
        gravity: "top",
        position: "right",
        backgroundColor: "#07BC0B",
      }).showToast();
    } catch (error) {
      console.error(error.message);
    } finally {
      if (submit_btn) {
        submit_btn.disabled = false;
        submit_btn.style.opacity = "";
      }
    }
  });

  const inquiries_popup = (all_inquiries) => {
    all_inquiries?.forEach((inquiry) => {
      if (inquiry.dataset.listenerAttached) return; // prevent duplicate listeners on re-observe
      inquiry.dataset.listenerAttached = "true";

      inquiry.addEventListener("click", async (e) => {
        e.preventDefault();
        const modal = document.getElementById(e.currentTarget.dataset.id);
        const modal_overlay = modal?.querySelector(".modal-overlay");
        const close_modal = modal?.querySelector(".close-modal");
        const form_message = modal?.querySelector(".form__message");
        if (form_message) {
          form_message.style.display = "none";
        }
        modal?.classList?.add("show-modal");

        // Lazy-load Turnstile script (no-op if already loaded) and render widget
        let widgetId = null;
        const container = modal?.querySelector(".cf-turnstile-container");
        if (container) {
          await loadTurnstile();
          widgetId = turnstile.render(container, {
            sitekey: TURNSTILE_SITE_KEY,
          });
        }

        const closeModal = () => {
          modal.classList.remove("show-modal");
          if (widgetId !== null) {
            turnstile.remove(widgetId);
            widgetId = null;
          }
        };

        modal_overlay?.addEventListener("click", closeModal, { once: true });
        close_modal?.addEventListener("click", closeModal, { once: true });
      });
    });
  };

  // Fallback: show toast if Shopify redirected back with ?contact_posted=true
  const success_popup = () => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("contact_posted") === "true") {
      Toastify({
        text: "Form submitted successfully",
        duration: 5000,
        gravity: "top",
        position: "right",
        backgroundColor: "#07BC0B",
      }).showToast();
    }
  };

  const inquiries = document.querySelectorAll(".inquire-btn");
  inquiries_popup(inquiries);
  success_popup();

  const related_products = document.getElementById("related-products");
  const observer = new MutationObserver(() => {
    // Form submissions handled by document-level delegation — no re-attachment needed
    const product_inquiries = related_products.querySelectorAll(".inquire-btn");
    inquiries_popup(product_inquiries);
  });

  if (related_products) {
    observer.observe(related_products, { childList: true, subtree: true });
  }
});
